import React from 'react';
import { Spacer } from '@ontruck/orc';

const journeyUpgradedRenderer = ({ changes, ...props }) => {
  const sosBefore = changes?.sos_before || [];
  const sosAfter = changes?.sos_after || [];
  const addPrefix = (item) => `S${item}`;
  return (
    <Spacer {...props}>
      {sosBefore.map(addPrefix).join(', ')} &#8594; {sosAfter.map(addPrefix).join(', ')}
    </Spacer>
  );
};

export default journeyUpgradedRenderer;
